<section
    class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 relative">
    <!-- Medical Pattern Background -->
    <div class="absolute inset-0 opacity-30">
        <div class="w-full h-full" style="background-image: 
        radial-gradient(circle at 25px 25px, rgba(99, 102, 241, 0.1) 2px, transparent 2px),
        radial-gradient(circle at 75px 75px, rgba(139, 92, 246, 0.1) 2px, transparent 2px);
        background-size: 100px 100px;">
        </div>
    </div>



    <!-- Login Container -->
    <div class="w-full flex flex-col justify-start items-center    relative z-10">
        <!-- Logo Section -->
       

        <!-- Login Form Card -->
        <div class="backdrop-blur-lg bg-white/85 max-w-md rounded-3xl p-8 shadow-2xl border border-white/20 animate-slide-up">
            <form [formGroup]="form" class="space-y-6" id="loginform">

                <div class="text-center mb-8 animate-fade-in">
                    <div class="flex items-center justify-center space-x-3 mb-4">
                        
                    </div>
                    <!-- <h1 class="text-3xl font-bold text-gray-800 mb-2">
                        Med<span class="text-indigo-600">Fest</span>
                    </h1> -->
                    <p class="text-gray-600">Welcome back! Please sign in to continue.</p>  </div>

                <!-- Error Messages -->
                <div *ngIf="isIncorrect"
                    class="bg-red-50 border border-red-200 rounded-xl p-4 text-red-700 text-sm animate-shake">
                    <div class="flex items-center justify-center space-x-2">
                        <svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        <span>{{ isIncorrect }}</span>
                    </div>
                </div>

                <!-- Email Verification Message -->
                <div *ngIf="emailVerify"
                    class="bg-amber-50 border border-amber-200 rounded-xl p-4 text-amber-700 text-sm">
                    <div class="flex items-center justify-center space-x-2 mb-3">
                        <svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        <span class="font-medium">Email verification required</span>
                    </div>
                    <div class="text-center">
                        <button type="button" (click)="navigateSendVerificationEmail()"
                            class="inline-flex items-center space-x-2 text-amber-800 hover:text-amber-900 font-medium transition-colors duration-200 underline hover:no-underline">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <span>Click here to verify your email</span>
                        </button>
                    </div>
                </div>

                <!-- Username Field -->
                <div class="space-y-2">
                    <label for="username" class="block text-sm font-semibold text-gray-700">Username</label>
                    <div class="relative group">
                        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10">
                            <svg class="w-5 h-5 text-gray-400 group-focus-within:text-indigo-500 transition-colors duration-200"
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <input type="text" id="username" formControlName="username"
                            [class]="'w-full pl-12 pr-4 py-3 border rounded-xl outline-none bg-white/70 backdrop-blur-sm transition-all duration-300 focus:transform focus:scale-[1.02] focus:shadow-lg ' + 
                        (submitted && f.username.errors ? 'border-red-300 focus:ring-2 focus:ring-red-200 focus:border-red-400' : 'border-gray-300 focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400')"
                            placeholder="Enter your username" autocomplete="username">
                    </div>
                    <div *ngIf="submitted && f.username.errors"
                        class="text-red-600 text-sm flex items-center space-x-1 animate-slide-down">
                        <svg class="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        <span *ngIf="f.username.errors.required">Username is required</span>
                    </div>
                </div>

                <!-- Password Field -->
                <div class="space-y-2">
                    <label for="password" class="block text-sm font-semibold text-gray-700">Password</label>
                    <div class="relative group">
                        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10">
                            <svg class="w-5 h-5 text-gray-400 group-focus-within:text-indigo-500 transition-colors duration-200"
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </div>
                        <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
                            [class]="'w-full pl-12 pr-12 py-3 border rounded-xl outline-none bg-white/70 backdrop-blur-sm transition-all duration-300 focus:transform focus:scale-[1.02] focus:shadow-lg ' + 
                        (submitted && f.password.errors ? 'border-red-300 focus:ring-2 focus:ring-red-200 focus:border-red-400' : 'border-gray-300 focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400')"
                            placeholder="Enter your password" autocomplete="current-password">
                        <button type="button" (click)="togglePasswordVisibility()"
                            class="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200 z-10">
                            <svg *ngIf="!showPassword" class="w-5 h-5" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            <svg *ngIf="showPassword" class="w-5 h-5" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                            </svg>
                        </button>
                    </div>
                    <div *ngIf="submitted && f.password.errors"
                        class="text-red-600 text-sm flex items-center space-x-1 animate-slide-down">
                        <svg class="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        <span *ngIf="f.password.errors.required">Password is required</span>
                    </div>
                </div>

                <!-- Remember Me & Forgot Password -->
                <div class="flex items-center justify-between pt-2">
                    <label class="flex items-center group cursor-pointer">
                        <input type="checkbox" id="rememberMe"
                            class="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 focus:ring-2 transition-all duration-200">
                        <span
                            class="ml-2 text-sm text-gray-700 group-hover:text-gray-900 transition-colors duration-200">Remember
                            me</span>
                    </label>
                    <button type="button" (click)="naviagteForgot()"
                        class="text-sm text-indigo-600 hover:text-indigo-800 transition-colors duration-200 font-medium flex items-center space-x-1 group">
                        <svg class="w-4 h-4 group-hover:transform group-hover:scale-110 transition-transform duration-200"
                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span>Forgot Password?</span>
                    </button>
                </div>

                <!-- Login Button -->
                <div class="pt-4">
                    <button type="submit" (click)="login()" [disabled]="isLoading"
                        class="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:hover:shadow-none flex items-center justify-center space-x-2">
                        <svg *ngIf="isLoading" class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        <svg *ngIf="!isLoading" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                        </svg>
                        <span>{{ isLoading ? 'Signing In...' : 'Sign In' }}</span>
                    </button>
                </div>

                <!-- Security Notice -->
                <div class="pt-4 text-center">
                    <div class="flex items-center justify-center space-x-4 text-xs text-gray-500">
                        <div class="flex items-center space-x-1">
                            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span>Secure Login</span>
                        </div>
                        <div class="w-1 h-1 bg-gray-300 rounded-full"></div>
                        <div class="flex items-center space-x-1">
                            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span>HIPAA Compliant</span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>

<!-- Required CSS for animations (add to your component's CSS file) -->
<style>
    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes float {

        0%,
        100% {
            transform: translateY(0px);
        }

        50% {
            transform: translateY(-10px);
        }
    }

    @keyframes shake {

        0%,
        100% {
            transform: translateX(0);
        }

        25% {
            transform: translateX(-5px);
        }

        75% {
            transform: translateX(5px);
        }
    }

    .animate-fade-in {
        animation: fadeIn 0.8s ease-in-out;
    }

    .animate-slide-up {
        animation: slideUp 0.6s ease-out;
    }

    .animate-slide-down {
        animation: slideDown 0.3s ease-out;
    }

    .animate-float {
        animation: float 6s ease-in-out infinite;
    }

    .animate-shake {
        animation: shake 0.5s ease-in-out;
    }

    </style>